 


<template>
  <AppLayout>
    <div class="transaction">
    <section id="transaction-products">
      <div class="container">
        
        <h6 style="margin-bottom: 0px;" class="fw-bold">Tender Management</h6>
        
        <!-- Stats Cards Section -->
        <div class="warehouse-inventory-card-wrapper">
          <div class="warehouse-inventory-card">
            <p>Draft <br>
              Tenders</p>
            <strong>{{ stats.draft || 0 }}</strong>
    
          </div>

          <div class="warehouse-inventory-card">
            <p>Published <br>
              Tenders</p>
            <strong class="green">{{ stats.published || 0 }}</strong>
          </div>

          <div class="warehouse-inventory-card">
            <p>Closed <br>
              Tenders</p>
            <strong class="red">{{ stats.closed || 0 }}</strong>
          </div>

          <div class="warehouse-inventory-card">
            <p>Total <br>
              Submissions</p>
            <strong>{{ stats.totalSubmissions || 0 }}</strong>
          </div>

          <div class="warehouse-inventory-card">
            <p>Pending <br>
              Reviews</p>
            <strong class="red">{{ stats.pendingReviews || 0 }}</strong>
          </div>

          <div class="warehouse-inventory-card">
            <p>Active <br>
              Tenders</p>
            <strong class="green">{{ stats.active || 0 }}</strong>
          </div>
        </div> 

        <!-- Filter Section -->
        <div class="filter-search" style="margin-top: 0px;padding-left: 0px;">
          <div class="filter-search-header">
            <p>Filter</p>
            <div class="header-actions">
              <p class="clear" @click="clear">Clear</p>
            </div>
          </div>
          <div class="filter-search-body">
            <div class="form">
              <div class="row">
                <div class="col-md-2 align-self-end">
                  <div class="form-group">
                    <label for="search">Search</label>
                    <input type="text" class="form-control" v-model="searchParams.search" placeholder="Title, Reference..." @input="debouncedSearch" />
                  </div>
                </div>
                <div class="col-md-2 align-self-end">
                  <div class="form-group">
                    <label for="status">Status</label>
                    <select class="full" v-model="searchParams.status" @change="fetchTenders">
                      <option value="">All</option>
                      <option value="DRAFT">Draft</option>
                      <option value="PUBLISHED">Published</option>
                      <option value="CLOSED">Closed</option>
                      <option value="CANCELLED">Cancelled</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-2 align-self-end">
                  <div class="form-group">
                    <label for="category">Category</label>
                    <select class="full" v-model="searchParams.category" @change="fetchTenders">
                      <option value="">All</option>
                      <option v-for="category in tenderCategories" :key="category.id" :value="category.name">
                        {{ category.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-2 align-self-end">
                  <div class="form-group">
                    <label for="dateFrom">Date From</label>
                    <input type="date" class="form-control" v-model="searchParams.dateFrom" @change="fetchTenders" />
                  </div>
                </div>
                <div class="col-md-2 align-self-end">
                  <div class="form-group">
                    <label for="dateTo">Date To</label>
                    <input type="date" class="form-control" v-model="searchParams.dateTo" @change="fetchTenders" />
                  </div>
                </div>
                <div class="col-md-2 align-self-end">
                  <div class="form-group">
                    <button class="btn btn-primary small" style="margin-top: 32px;" type="button" @click="fetchTenders">Search</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Tenders Table -->
        <div class="products-list transaction-products-list" style="margin-top: 0px;">
          <!--<h6 class="fw-bold">Tenders Table</h6>-->
          
          <!-- Skeleton loader for tenders table -->
          <SkeletonLoader v-if="loading" type="table" :rows="8" :columns="8" />
          
          <table v-else id="tendersTable" ref="tendersTable" class="table table-hover">
            <thead style="background-color: #f8f9fa; border-bottom: 2px solid #dee2e6;">
              <tr>
                <th style="padding: 15px 11px; font-weight: 600; font-size: 11px; color: #495057; text-align: left; border-bottom: none;">No.</th>
                <th style="padding: 15px 11px; font-weight: 600; font-size: 11px; color: #495057; text-align: left; border-bottom: none;">Reference</th>
                <th style="padding: 15px 11px; font-weight: 600; font-size: 11px; color: #495057; text-align: left; border-bottom: none;">Title</th>
                <th style="padding: 15px 11px; font-weight: 600; font-size: 11px; color: #495057; text-align: left; border-bottom: none;">Category</th>
                <th style="padding: 15px 11px; font-weight: 600; font-size: 11px; color: #495057; text-align: left; border-bottom: none;">Status</th>
                <th style="padding: 15px 11px; font-weight: 600; font-size: 11px; color: #495057; text-align: left; border-bottom: none;">Published</th>
                <th style="padding: 15px 11px; font-weight: 600; font-size: 11px; color: #495057; text-align: left; border-bottom: none;">Deadline</th>
                <th style="padding: 15px 11px; font-weight: 600; font-size: 11px; color: #495057; text-align: left; border-bottom: none;">Submissions</th>
                <th style="padding: 15px 11px; font-weight: 600; font-size: 11px; color: #495057; text-align: left; border-bottom: none;">PR No</th>
                <th style="padding: 15px 11px; font-weight: 600; font-size: 11px; color: #495057; text-align: left; border-bottom: none;">Actions</th>
              </tr>
            </thead>
            <tbody v-if="!loading && tenders?.length > 0">
              <tr v-for="(tender, index) in tenders" :key="tender.id">
                <td>{{ index + 1 }}</td>
                <td>{{ tender.referenceNumber || tender.reference || 'N/A' }}</td>
                <td>{{ tender.title }}</td>
                <td>{{ (tender.category && (tender.category.name || tender.category)) || 'N/A' }}</td>
                <td>
                  <span :class="`badge badge-${tender.status === 'DRAFT' ? 'warning' : tender.status === 'PUBLISHED' ? 'success' : 'danger'} tender-status-badge`">
                    {{ formatStatus(tender.status) }}
                  </span>
                </td>
                <td>{{ formatDate(tender.publishDate || tender.publishedAt || tender.publishedDate) }}</td>
                <td>{{ formatDate(tender.submissionDeadline) }}</td>
                <td>{{ tender._count?.submissions ?? tender.submissionCount ?? 0 }}</td>
                <td>
                  <template v-if="tender.purchaseRequest?.purchaseRequestNo">
                    {{ tender.purchaseRequest.purchaseRequestNo }}
                  </template>
                  <template v-else-if="(tender._count?.purchases ?? tender._count?.Purchase ?? tender.purchaseCount ?? 0) > 0">
                    <button @click="viewPurchaseRequests(tender)" class="btn btn-sm btn-outline-primary" title="View Purchase Requests">
                      PR ({{ tender._count?.purchases ?? tender._count?.Purchase ?? tender.purchaseCount ?? 0 }})
                    </button>
                  </template>
                  <span v-else>—</span>
                </td>
                <td>
                  <div class="btn-group" role="group">
                    <button
                      v-if="tender.status !== 'CLOSED'"
                      @click="editTender(tender.id)"
                      class="btn btn-sm btn-outline-secondary"
                      title="Edit Tender"
                    >
                      <i class="fas fa-edit"></i>
                    </button>
                    <button
                      v-if="['PUBLISHED', 'CLOSED'].includes(tender.status)"
                      @click="viewSubmissions(tender.id)"
                      class="btn btn-sm btn-outline-info"
                      title="View Submissions"
                    >
                      <i class="fas fa-file-alt"></i>
                    </button>
                    <button
                      v-if="tender.status === 'DRAFT'"
                      @click="publishTender(tender.id)"
                      class="btn btn-sm btn-outline-success"
                      title="Publish Tender"
                    >
                      <i class="fas fa-bullhorn"></i>
                    </button>
                    <button
                      v-if="tender.status === 'PUBLISHED'"
                      @click="openInviteModal(tender)"
                      class="btn btn-sm btn-outline-success"
                      title="Invite Suppliers"
                    >
                      <i class="fas fa-user-plus"></i>
                    </button>
                    <button
                      v-if="tender.status === 'PUBLISHED'"
                      @click="copyTenderLink(tender.slug)"
                      class="btn btn-sm btn-outline-warning"
                      title="Copy Link"
                    >
                      <i class="fas fa-link"></i>
                    </button>
                    <button
                      v-if="tender.status === 'PUBLISHED'"
                      @click="endTender(tender.id)"
                      class="btn btn-sm btn-outline-danger"
                      title="End Tender"
                    >
                      <i class="fas fa-stop-circle"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
    </div>

    <!-- Invite Suppliers Modal -->
    <div v-if="showInviteModal" class="modal-overlay" @click.self="closeInviteModal">
      <div class="modal-box" style="max-width:550px;">
        <div class="modal-header-bar">
          <h6 class="fw-bold mb-0" style="font-size: 11px; opacity: 0.9 !important;">Invite Suppliers — {{ inviteTender?.title }}</h6>
          <button class="btn-close-plain" @click="closeInviteModal">&times;</button>
        </div>
        <div class="modal-body-area">
          <div class="form-group mb-3">
            <input type="text" class="form-control form-control-sm" placeholder="Search suppliers..." v-model="supplierSearch" />
          </div>
          <div class="supplier-list">
            <div v-if="loadingSuppliers" class="text-center py-3 text-muted small">Loading suppliers...</div>
            <div v-else-if="filteredSuppliers.length === 0" class="text-center py-3 text-muted small">No suppliers found.</div>
            <label
              v-for="sup in filteredSuppliers"
              :key="sup.id"
              class="supplier-row"
              :class="{ selected: selectedSupplierIds.includes(sup.id) }"
            >
              <input type="checkbox" :value="sup.id" v-model="selectedSupplierIds" />
              <span class="supplier-name">{{ sup.name }}</span>
              <span class="supplier-email text-muted">{{ sup.email || 'No email' }}</span>
            </label>
          </div>
          <p class="small text-muted mt-2">{{ selectedSupplierIds.length }} supplier(s) selected</p>
        </div>
        <div class="modal-footer-bar">
          <button class="btn btn-sm btn-style-2" @click="closeInviteModal">Cancel</button>
          <button
            class="btn btn-sm btn-success send-invites-btn"
            :class="{ 'send-invites-btn--sending': sendingInvites }"
            :disabled="selectedSupplierIds.length === 0 || sendingInvites"
            @click="sendInvites"
          >
            <span v-if="sendingInvites">
              <i class="fas fa-spinner fa-spin me-1"></i>Sending...
            </span>
            <span v-else>
              <i class="fas fa-paper-plane me-1 send-invites-btn__plane"></i>
            </span>
          </button>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import { ref, reactive, computed, onMounted, onBeforeUnmount,  } from 'vue'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { API_BASE_URL, tenderApi } from '@/api/tender'
import { useRouter } from 'vue-router'
import AppLayout from '../../components/AppLayout.vue'
import SkeletonLoader from '../../components/SkeletonLoader'
import 'datatables.net-vue3'
import 'datatables.net-bs5'
import "datatables.net-buttons-bs5"
import "datatables.net-responsive-bs5"
import 'jszip'
import 'datatables.net-buttons/js/buttons.html5.js'
import 'datatables.net-buttons/js/buttons.colVis.js'
import 'datatables.net-buttons/js/buttons.print.js'


// Simple utility functions
const showToast = (message, type = 'info') => {
  console.log(`${type.toUpperCase()}: ${message}`)
  // You can replace this with your preferred toast library
}

const debounce = (func, delay) => {
  let timeoutId
  return function (...args) {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => func.apply(this, args), delay)
  }
}

export default {
  name: 'TenderManagement',
  components: {
    AppLayout,
    SkeletonLoader
  },

  setup() {
    const router = useRouter()
    const loading = ref(false)
    const showCreateForm = ref(false)
    const selectedTender = ref(null)
    const tendersTable = ref(null)
    let dataTable = null
    
    const stats = reactive({
      total: 0,
      draft: 0,
      published: 0,
      closed: 0,
    })
    
    const searchParams = reactive({
      search: '',
      category: '',
      status: '',
      page: 1,
      limit: 1000,
    })
    
    const tenders = ref([])
    const tenderCategories = ref([])
    const totalTenders = ref(0)
    const totalPages = ref(0)
    
    const currentPage = computed(() => searchParams.page)
    
    // Use the token as a string, not parsed JSON
      const token = JSON.parse(localStorage.getItem('access_token'))
      // canonical API base
      const API_BASE = API_BASE_URL
    const fetchTenders = async () => {
      loading.value = true
      try {
        // Build query string from searchParams
        const params = { ...searchParams }
        Object.keys(params).forEach(key => {
          if (params[key] === '' || params[key] === null || params[key] === undefined) {
            delete params[key]
          }
        })
        const query = new URLSearchParams(params).toString()
        const res = await fetch(`${API_BASE}/tender?${query}`, {
          headers: {
            'Accept': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
          }
        })
        if (!res.ok) {
          let msg = 'Failed to load tenders'
          try {
            const err = await res.json()
            msg = err?.error || err?.message || msg
          } catch (e) {/* ignore */}
          throw new Error(msg)
        }
        const data = await res.json()
        tenders.value = data.data || []
        totalTenders.value = data.total || 0
        totalPages.value = data.totalPages || 1
      } catch (error) {
        showToast('Error fetching tenders', 'error')
        console.error('Error fetching tenders:', error)
      } finally {
        loading.value = false
        // initialize datatable after DOM updated
        setTimeout(initializeDataTable, 50)
      }
    }
    
    const fetchStats = async () => {
      try {
        const res = await fetch(`${API_BASE}/tender/stats`, {
          headers: {
            'Accept': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
          }
        })
        if (!res.ok) {
          let msg = 'Failed to load stats'
          try {
            const err = await res.json()
            msg = err?.error || err?.message || msg
          } catch (e) {/* ignore */}
          throw new Error(msg)
        }
        const data = await res.json()
        Object.assign(stats, data.data || data)
      } catch (error) {
        console.error('Error fetching stats:', error)
      }
    }
    
    const debouncedSearch = debounce(() => {
      searchParams.page = 1
      fetchTenders()
    }, 500)

    const initializeDataTable = () => {
      try {
        if (!tendersTable.value) return
        if (dataTable) { dataTable.destroy(); dataTable = null }
        dataTable = $(tendersTable.value).DataTable({
          dom: 'Bfrtip',
          responsive: true,
          language: {
            paginate: {
              previous: '<i class="fas fa-chevron-left"></i>',
              next: '<i class="fas fa-chevron-right"></i>',
            },
          },
          buttons: [
            'colvis',
            'pageLength',
            { extend: 'csv', text: 'Export CSV', className: 'btn btn-primary btn-sm' },
            { extend: 'excel', text: 'Export Excel', className: 'btn btn-primary btn-sm' },
            { extend: 'print', text: 'Print', className: 'btn btn-secondary btn-sm' },
          ],
        })
      } catch (err) {
        console.warn('DataTable init failed', err)
      }
    }
    
    const goToPage = (page) => {
      if (page >= 1 && page <= totalPages.value) {
        searchParams.page = page
        fetchTenders()
      }
    }

    // eslint-disable-next-line no-unused-vars
    const viewPurchaseRequests = (tender) => {
      // Navigate to the purchases list filtered by this tender
      const id = tender?.id || tender?.tid || ''
      router.push({ path: '/purchases', query: { tenderId: String(id) } })
    }
    
    const editTender = (id) => {
      router.push(`/admin/tenders/${id}/edit`)
    }
    
    const viewSubmissions = (id) => {
      router.push(`/admin/tenders/${id}/submissions`)
    }
    
    const publishTender = async (id) => {
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: 'Are you sure you want to publish this tender? It will become publicly accessible.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, publish it!'
      })
      if (!result.isConfirmed) {
        return
      }
      try {
        const res = await fetch(`${API_BASE}/tender/${id}/publish`, {
          method: 'PUT',
          headers: {
            'Accept': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
          }
        })
        if (!res.ok) {
          let msg = 'Failed to publish tender'
          try {
            const err = await res.json()
            msg = err?.error || err?.message || msg
          } catch (e) {/* ignore */}
          throw new Error(msg)
        }
        showToast('Tender published successfully', 'success')
        fetchTenders()
        fetchStats()
      } catch (error) {
        showToast('Error publishing tender', 'error')
      }
    }

    const endTender = async (id) => {
      const result = await Swal.fire({
        title: 'End Tender?',
        text: 'This will close the tender. Suppliers will no longer be able to submit quotations via the public URL or email links.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Yes, end it'
      })
      if (!result.isConfirmed) return
      try {
        await tenderApi.updateTender(id, { status: 'CLOSED' })
        showToast('Tender ended successfully. Submissions are now closed.', 'success')
        fetchTenders()
        fetchStats()
      } catch (error) {
        showToast(error?.message || 'Error ending tender', 'error')
      }
    }
    
    const copyTenderLink = async (slug) => {
      if (!slug) {
        showToast('No tender link available', 'error')
        return
      }
      const url = `${window.location.origin}/tenders/${slug}`
      try {
        await navigator.clipboard.writeText(url)
        alert('Link copied: ' + url)
        showToast('Tender link copied to clipboard', 'success')
      } catch (err) {
        showToast('Failed to copy link', 'error')
      }
    }
    
    const onTenderSaved = () => {
      showCreateForm.value = false
      selectedTender.value = null
      fetchTenders()
      fetchStats()
      showToast('Tender saved successfully', 'success')
    }
    
    const formatDate = (dateString) => {
      if (!dateString) return 'N/A'
      const d = new Date(dateString)
      if (isNaN(d.getTime())) return 'Invalid Date'
      return d.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      })
    }

    const formatStatus = (status) => {
      if (!status) return ''
      const s = String(status).toLowerCase()
      return s.charAt(0).toUpperCase() + s.slice(1)
    }

    // ── Invite Suppliers ────────────────────────────────────────────
    const showInviteModal = ref(false)
    const inviteTender = ref(null)
    const allSuppliers = ref([])
    const loadingSuppliers = ref(false)
    const selectedSupplierIds = ref([])
    const supplierSearch = ref('')
    const sendingInvites = ref(false)

    const filteredSuppliers = computed(() => {
      const q = supplierSearch.value.toLowerCase().trim()
      if (!q) return allSuppliers.value
      return allSuppliers.value.filter(s =>
        (s.name || '').toLowerCase().includes(q) ||
        (s.email || '').toLowerCase().includes(q)
      )
    })

    const fetchAllSuppliers = async () => {
      loadingSuppliers.value = true
      try {
        const res = await fetch(`${API_BASE}/suppliers?limit=500`, {
          headers: { Authorization: token ? `Bearer ${token}` : '' }
        })
        const data = await res.json()
        allSuppliers.value = Array.isArray(data) ? data : (data.data || data.suppliers || [])
      } catch (e) {
        allSuppliers.value = []
      } finally {
        loadingSuppliers.value = false
      }
    }

    const openInviteModal = async (tender) => {
      inviteTender.value = tender
      selectedSupplierIds.value = []
      supplierSearch.value = ''
      showInviteModal.value = true
      await fetchAllSuppliers()
    }

    const closeInviteModal = () => {
      showInviteModal.value = false
      inviteTender.value = null
    }

    const sendInvites = async () => {
      if (!inviteTender.value || selectedSupplierIds.value.length === 0) return
      sendingInvites.value = true
      try {
        const res = await fetch(`${API_BASE}/tender/${inviteTender.value.id}/invite-suppliers`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: token ? `Bearer ${token}` : ''
          },
          body: JSON.stringify({ supplierIds: selectedSupplierIds.value })
        })
        const data = await res.json()
        if (!res.ok) throw new Error(data?.message || 'Failed to send invitations')
        Swal.fire({
          icon: 'success',
          title: 'Invitations Sent',
          text: `${data.invited} of ${data.total} supplier(s) were emailed successfully.`,
          confirmButtonColor: '#3085d6'
        })
        closeInviteModal()
      } catch (err) {
        Swal.fire({ icon: 'error', title: 'Error', text: err.message })
      } finally {
        sendingInvites.value = false
      }
    }
    // ────────────────────────────────────────────────────────────────

    onMounted(() => {
      fetchTenders()
      fetchStats()
    })

    onBeforeUnmount(() => {
      try { if (dataTable) { dataTable.destroy(); dataTable = null } } catch (e) { /* ignore */ }
    })
    
    return {
      loading,
      showCreateForm,
      selectedTender,
      stats,
      searchParams,
      tenders,
      totalTenders,
      totalPages,
      currentPage,
      fetchTenders,
      debouncedSearch,
      goToPage,
      editTender,
      viewSubmissions,
      publishTender,
      endTender,
      copyTenderLink,
      onTenderSaved,
      formatDate,
      formatStatus,
      tendersTable,
      tenderCategories,
      // invite suppliers
      showInviteModal,
      inviteTender,
      allSuppliers,
      loadingSuppliers,
      selectedSupplierIds,
      supplierSearch,
      filteredSuppliers,
      sendingInvites,
      openInviteModal,
      closeInviteModal,
      sendInvites,
    }
  },
}
</script>

<style scoped>
/* Reuse styles from HomeTransactions.vue */
.tender-management {
  min-height: 100vh;
  background-color: #f8f9fa;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 32px;
}

.title-section h1 {
  font-size: 28px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 8px 0;
}

.title-section p {
  color: #666;
  margin: 0;
}

.stats-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 32px;
}

.stat-card {
  background: white;
  border-radius: 11px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 13px;
}

.stat-icon {
  width: 48px;
  height: 48px;
  border-radius: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
}

.stat-icon.draft { background: #f59e0b; }
.stat-icon.published { background: #10b981; }
.stat-icon.closed { background: #6b7280; }
.stat-icon.total { background: #3b82f6; }

.stat-content h3 {
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 4px 0;
  color: #1a1a1a;
}

.stat-content p {
  color: #666;
  margin: 0;
  font-size: 13px;
}

.search-section {
  background: white;
  border-radius: 11px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.search-filters {
  display: flex;
  gap: 13px;
  align-items: center;
}

.search-input {
  position: relative;
  flex: 1;
}

.search-input i {
  position: absolute;
  left: 13px;
  top: 50%;
  transform: translateY(-50%);
  color: #666;
}

.search-input input {
  width: 100%;
  padding: 11px 13px 11px 44px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
}

.search-input input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

select {
  padding: 11px 13px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  min-width: 140px;
}

select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.loading {
  text-align: center;
  padding: 48px;
  color: #666;
}

.loading i {
  font-size: 24px;
  margin-bottom: 13px;
}

.empty-state {
  text-align: center;
  padding: 48px;
  color: #666;
}

.empty-state i {
  font-size: 48px;
  margin-bottom: 13px;
  color: #d1d5db;
}

.tender-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 24px;
}

.tender-card {
  background: white;
  border-radius: 11px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.2s ease;
}

.tender-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.tender-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 13px;
}

.tender-ref {
  font-family: monospace;
  font-size: 11px;
  color: #666;
  background: #f3f4f6;
  padding: 4px 8px;
  border-radius: 4px;
}

.tender-status {
  padding: 4px 11px;
  border-radius: 13px;
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
}

.tender-status.draft { background: #fef3c7; color: #92400e; }
.tender-status.published { background: #d1fae5; color: #065f46; }
.tender-status.closed { background: #f3f4f6; color: #374151; }
.tender-status.cancelled { background: #fee2e2; color: #991b1b; }

/* Override dark-mode.css badge uppercase - need high specificity */
#tendersTable .tender-status-badge,
#tendersTable .badge.tender-status-badge {
  text-transform: capitalize !important;
}

.tender-content h3 {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 8px 0;
  color: #1a1a1a;
}

.tender-description {
  color: #666;
  font-size: 13px;
  margin: 0 0 13px 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.tender-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 13px;
  margin-bottom: 13px;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #666;
  font-size: 11px;
}

.meta-item i {
  width: 13px;
}

.tender-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.btn {
  padding: 8px 13px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid transparent;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.btn-primary {
  background: #3b82f6;
  color: white;
}

.btn-primary:hover {
  background: #2563eb;
}

.btn-outline {
  border: 1px solid #e5e7eb;
  color: #374151;
  background: white;
}

.btn-outline:hover {
  background: #f9fafb;
  border-color: #d1d5db;
}

.btn-success {
  background: #10b981;
  color: white;
}

.btn-success:hover {
  background: #059669;
}

.btn-info {
  background: #0ea5e9;
  color: white;
}

.btn-info:hover {
  background: #0284c7;
}

.btn-sm {
  padding: 6px 11px;
  font-size: 11px;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 13px;
  margin-top: 32px;
}

.page-info {
  color: #666;
  font-size: 13px;
}

@media (max-width: 768px) {
  .header {
    flex-direction: column;
    gap: 13px;
    align-items: stretch;
  }

  .search-filters {
    flex-direction: column;
    gap: 11px;
  }

  .tender-cards {
    grid-template-columns: 1fr;
  }

  .tender-actions {
    justify-content: space-between;
  }
}

/* Invite suppliers modal */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.45);
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-box {
  background: #fff;
  border-radius: 8px;
  width: 100%;
  box-shadow: 0 8px 32px rgba(0,0,0,.18);
  display: flex;
  flex-direction: column;
  max-height: 80vh;
}

.modal-header-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 18px;
  border-bottom: 1px solid #e9ecef;
}

.btn-close-plain {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #6c757d;
  line-height: 1;
}

.modal-body-area {
  padding: 16px 18px;
  overflow-y: auto;
  flex: 1;
}

.modal-footer-bar {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 11px 18px;
  border-top: 1px solid #e9ecef;
}

.supplier-list {
  border: 1px solid #dee2e6;
  border-radius: 6px;
  max-height: 280px;
  overflow-y: auto;
}

.supplier-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 11px;
  cursor: pointer;
  border-bottom: 1px solid #f1f1f1;
  transition: background .12s;
}

.supplier-row:last-child { border-bottom: none; }
.supplier-row:hover { background: #f8f9fa; }
.supplier-row.selected { background: #e8f4fd; }

.supplier-name { font-size: 11px; font-weight: 500; flex: 1; }
.supplier-email { font-size: 11px; }

/* Send Invitations button - subtle send animation */
.send-invites-btn {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.send-invites-btn__plane {
  display: inline-block;
}
.send-invites-btn:hover:not(:disabled) .send-invites-btn__plane {
  animation: send-plane-hover 0.6s ease;
}
.send-invites-btn--sending {
  animation: send-pulse 1.2s ease-in-out infinite;
}
@keyframes send-plane-hover {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  25% { transform: translate(2px, -2px) rotate(-8deg); }
  75% { transform: translate(4px, -4px) rotate(-12deg); }
}
@keyframes send-pulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.92; transform: scale(0.99); }
}
</style>